/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupstatuswaitlist2Inputs */

const en_signupstatuswaitlist2 = /** @type {(inputs: Signupstatuswaitlist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting list`)
};

const de_signupstatuswaitlist2 = /** @type {(inputs: Signupstatuswaitlist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warteliste`)
};

/**
* | output |
* | --- |
* | "Waiting list" |
*
* @param {Signupstatuswaitlist2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupstatuswaitlist2 = /** @type {((inputs?: Signupstatuswaitlist2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupstatuswaitlist2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupstatuswaitlist2(inputs)
	return de_signupstatuswaitlist2(inputs)
});
export { signupstatuswaitlist2 as "signupStatusWaitlist" }